import React from 'react';
import { usePlatform } from '../platform/PlatformContext';
import { DeadCenterHome } from './DeadCenterHome';

/**
 * DeadCenterPage
 * Renders the /deadcenter landing page only.
 * The "Play" CTA navigates intentionally to /deadcenter/daily
 * which App.js routes to the dedicated DcAppShell game shell.
 */
export default function DeadCenterPage() {
  const { navigate } = usePlatform();
  return <DeadCenterHome onPlay={() => navigate('/deadcenter/daily')} />;
}
